import { Text } from 'react-native';
import { useTimer } from './hooks';
import { formatMillisecondsToDurationString } from './utils';

//#region Public Interface

interface Props {
  isRunning: boolean;
  interval?: number;
  onTick: (now: Date) => number;
}

export function TimerText({ isRunning, interval = 1000, onTick }: Props) {
  const now = useTimer(interval, isRunning);
  const duration = onTick(now);
  const durationString = formatMillisecondsToDurationString(duration, true);
  return <Text style={{ fontVariant: ['tabular-nums'] }}>{durationString}</Text>;
}

//#endregion
